import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslationService} from '@emma-labs/shared/angular';
import {MIBReply} from '@emma-labs/shared/typescript';
import {InputTextModule} from 'primeng/inputtext';
import {formatOptionalCountryStateAndTerritory} from '../utils';

@Component({
  selector: 'em-details-section',
  templateUrl: './details-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, InputTextModule],
})
export class DetailsSectionComponent {
  @Input({required: true}) data!: MIBReply;

  constructor(private readonly translate: TranslationService) {}

  get birthPlace() {
    return formatOptionalCountryStateAndTerritory(
      this.data.birthCountry,
      this.data.birthState,
      undefined,
      this.translate.getCurrentLanguageCode(),
    );
  }

  get residencePlace() {
    return formatOptionalCountryStateAndTerritory(
      this.data.residenceCountry,
      this.data.residenceState,
      this.data.residenceTerritory,
      this.translate.getCurrentLanguageCode(),
    );
  }

  get alternateBirthdays() {
    return this.data.alternateBirthdays?.join(', ');
  }
}
